import { ResourceModel, UserModel } from '@/models';
import { AsyncResourceOptions } from 'async_hooks';

export class Resource {
    /**
     * Whether a user can create a new resource.
     *
     * @param {User=} user
     * @returns {boolean}
     */
    public static canCreate(user?: UserModel): boolean {
        const result = user && (user.hasPermission('resources.create') || user.hasPermission('resources.manage'));
        return Boolean(result);
    }

    /**
     * Whether a user can delete a resource.
     *
     * @param {User=} user
     * @param {ResourceModel=} resource
     * @returns {boolean}
     */
    public static canDelete(user?: UserModel, resource?: ResourceModel): boolean {
        if (!user) { return false; }

        if (user.hasPermission('resources.manage')) {
            return true;
        }

        // users can delete their own resources
        if (resource && resource.data.user_id === user.data.id) {
            return true;
        }

        return false;
    }

    /**
     * Whether a user can manage an existing resource.
     *
     * @param {User=} user
     * @param {ResourceModel=} resource
     * @returns {boolean}
     */
    public static canManage(user?: UserModel, resource?: ResourceModel): boolean {
        if (!resource || !user) { return false; }

        // users can manage their own posts
        if (resource.data.user_id === user.data.id) {
            return true;
        }

        if (user.hasPermission('resources.manage')) {
            return true;
        }

        return false;
    }

    /**
     * Whether a user can manage a resources' status field.
     *
     * @param {UserModel=} user
     * @returns {boolean}
     */
    public static canManageStatus(user?: UserModel): boolean {
        if (!user) { return false; }
        return user.hasPermission('resources.manage');
    }
}

export default Resource;
